import styled from 'styled-components';

export const ConcentricLocationsModalStyled = styled.div`
  .concentricLocationsModal {
    &__separator {
      margin: 16px 0;
      width: 100%;
      border-bottom: 1px solid ${props => props.theme.uiColors.contrastScaleSoft};
    }

    &__radiusList {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`;
